import { useTranslation } from 'react-i18next';
import { XCircle } from 'lucide-react';
import { formatDate } from '@/lib/utils';
import type { AdminErrorHighlight } from '@/types/admin-trace';

/**
 * Fehler-Highlights des Trace (Spec 143 §4 Basis-Trace-Rendering).
 * Sparse-TXs liefern errors: [] → nichts rendern (Trap §8.8).
 */
export function TraceErrors({ errors }: { errors: AdminErrorHighlight[] }) {
  const { t } = useTranslation('transactions');

  if (errors.length === 0) return null;

  return (
    <div className="space-y-2" data-testid="trace-errors">
      <p className="text-sm font-medium text-red-700">{t('trace.errors.title')}</p>
      {errors.map((err, idx) => (
        <div
          key={`${err.code}-${idx}`}
          className="flex items-start gap-2 rounded-md border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-800"
        >
          <XCircle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
          <div className="min-w-0 space-y-0.5">
            <p className="break-words">
              <span className="break-all font-mono text-xs">{err.code}</span>
              {err.message ? <> — {err.message}</> : null}
            </p>
            <p className="text-xs text-red-700/80">
              {t('trace.errors.source')}: {err.source}
              {err.phase && <> · {err.phase}</>}
              {err.reportStatusCode != null && (
                <> · {t('trace.errors.statusCode')}: <span className="font-mono">{err.reportStatusCode}</span></>
              )}
              {err.timestamp && <> · {formatDate(err.timestamp)}</>}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
